export const serializeForm = refs => {
    const form = {};
    const refKeys = Object.keys(refs);
    refKeys.forEach(key => {
        if (refs[key].state) {
            form[key] = refs[key].state.value;
        }
    });
    return form;
};

export const isValid = refs => {
    const refKeys = Object.keys(refs);
    return refKeys.every(key => {
        if (typeof refs[key].isValid !== 'function') return true;
        return refs[key].isValid();
    });
};



// WEBPACK FOOTER //
// ./src/app/pages/credit/creditUtils.js